/*
 * Compares two Date objects and returns a number indicating their relative order.
 * @param date1 - The first Date object to compare.
 * @param date2 - The second Date object to compare.
 * @returns A negative number if date1 is earlier than date2, a positive number if date1 is later than date2, or 0 if they are equal.
 */

export const compareDates = (date1: Date, date2: Date): number => {
  const time1 = date1.getTime();
  const time2 = date2.getTime();

  if (time1 < time2) {
    return -1;
  }
  if (time1 > time2) {
    return 1;
  }
  return 0;
};
